"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _index = require("./index.styles");

var _excluded = ["name", "to", "Icon"];

var DesktopNavigation = function DesktopNavigation(_ref) {
  var items = _ref.items,
      LinkComponent = _ref.LinkComponent,
      ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_react["default"].createElement(_index.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_index.Container, null, /*#__PURE__*/_react["default"].createElement(_index.Nav, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_index.List, null, items.map(function (_ref2) {
    var name = _ref2.name,
        to = _ref2.to,
        Icon = _ref2.Icon,
        otherProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_index.ListItem, {
      key: to
    }, /*#__PURE__*/_react["default"].createElement(LinkComponent, (0, _extends2["default"])({
      to: to
    }, otherProps), name));
  })))));
};

DesktopNavigation.propTypes = {
  LinkComponent: _propTypes.elementType.isRequired,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    Icon: _propTypes.elementType,
    to: _propTypes.string.isRequired
  })).isRequired,
  ariaLabel: _propTypes.string.isRequired
};
var _default = DesktopNavigation;
exports["default"] = _default;